import useFetchChartData from '@hooks/useFetchChartData'
import {
  AnalyticsGraphDataBase,
  FetchUserAnalyticsGraphParams,
} from '@models/user/UserAnalyticsGraph'
import { fetchAnalyticsGraph } from '@services/AnalyticsGraph'
import { plethorePalette } from '@utils/colors'
import { FC } from 'react'
import { Bar, BarChart, Cell, Tooltip, YAxis } from 'recharts'
import { NumberFormatedAxisTick } from '../common/AxisTicks'
import BaseChart from '../common/BaseChart'
import CustomTooltip from '../common/CustomTooltip'
import { useBarColors } from '../common/useBarColors'

const AppMostViewedScreen: FC = () => {
  const { data, isLoading, error } = useFetchChartData<
    FetchUserAnalyticsGraphParams,
    AnalyticsGraphDataBase
  >({
    entity: 'user',
    kind: 'app-screens-most-viewed',
    fetchFunction: fetchAnalyticsGraph,
  })
  const barColors = useBarColors(data, 'count', plethorePalette)

  return (
    <BaseChart
      title="20 most viewed screens"
      help="Top 20 most viewed screens (across all pages and routes combined) in the app over the selected time range."
      data={data}
      isLoading={isLoading}
      error={error}
      height={350}
    >
      <BarChart data={data}>
        <YAxis
          dataKey="count"
          tickLine={false}
          stroke={'#bbb'}
          width={35}
          tick={(props) => <NumberFormatedAxisTick {...props} />}
        />

        <Tooltip
          content={(props) => (
            <CustomTooltip
              type="bar"
              {...props}
              valueFormatter={(val) => val + '  views'}
              customLabelFormatter={(payload) => {
                return payload.label == '$$_posthog_breakdown_other_$$'
                  ? 'Others'
                  : payload.label
              }}
            />
          )}
        />
        <Bar dataKey="count">
          {barColors.map((color, index) => (
            <Cell key={index} fill={color} />
          ))}
        </Bar>
      </BarChart>
    </BaseChart>
  )
}

export default AppMostViewedScreen
